module.exports = __webpack_public_path__ + "static/img/Training-location.d96f6893.png";